/**
 * Every cache entry is namespaced by the logged-in user's id. This is what
 * makes a shared machine safe: a different login can never read the previous
 * user's entries, even before the logout wipe runs.
 */

export const ANON_NS = 'anon';

function decodeJwtSub(token: string): string | null {
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const claims = JSON.parse(atob(padded));
    const sub = claims?.sub;
    return typeof sub === 'string' && sub ? sub : null;
  } catch {
    return null;
  }
}

export function getCacheNamespace(): string {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) return ANON_NS;
    return decodeJwtSub(token) ?? ANON_NS;
  } catch {
    return ANON_NS;
  }
}
